import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDKJFIKzCtitVP9xxB00wRdwz4y4jq9Ybc",
  authDomain: "underground-project-c59ff.firebaseapp.com",
  projectId: "underground-project-c59ff",
  storageBucket: "underground-project-c59ff.firebasestorage.app",
  messagingSenderId: "829248171165",
  appId: "1:829248171165:web:87dc7ae2366a171090b874",
  measurementId: "G-DQCDETJHML",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

if (typeof window !== "undefined") {
  // Check if we're in an iframe
  const isEmbedded = window.self !== window.top;

  if (isEmbedded) {
    // Safari-specific auth settings for iframe
    auth.settings = {
      appVerificationDisabledForTesting: false,
    };

    // console.log("Safari Debug: Configured auth for iframe context");
  }
}

export const googleProvider = new GoogleAuthProvider();

export const db = getFirestore(app);
